<div
  *ngIf="filterOptions"
  class="flex items-center w-full md:w-fit
{{ classNames }}"
  appClickOutside
  (clickOutside)="clickedOutside()"
>
  <div
    *ngIf="isOpen && backdrop"
    class="fixed z-modal-backdrop inset-0 bg-blue opacity-50"
    (click)="close()"
  ></div>

  <div class="relative w-full md:w-fit">
    <div
      class="cursor-pointer w-full {{
        caller === '_CORPORATE'
          ? 'md:w-60 bg-white px-2 rounded-md py-2'
          : variant === '_MENU'
          ? 'bg-black bg-opacity-20 w-full h-[56px] px-6 flex items-center justify-center'
          : 'bg-blue bg-opacity-5 px-2 rounded-md py-2'
      }}  "
      (click)="openfilterSelect()"
    >
      <ng-container [ngTemplateOutlet]="filterDropdown"></ng-container>
    </div>
    <ul
      *ngIf="isOpen"
      class="{{
        variant === '_MENU'
          ? 'w-full bg-black bg-opacity-20 overflow-ellipsis'
          : 'absolute rounded-lg shadow-map-africa-box bg-white overflow-auto mt-1 z-modal-backdrop w-[350px]'
      }} p-2"
    >
      <div
        *ngFor="let option of filterOptions"
        class="cursor-pointer w-full rounded-md {{
          option.label === pickValue?.label
            ? 'bg-blue text-white transition-none'
            : variant === '_MENU'
            ? 'bg-white bg-opacity-5'
            : 'bg-blue bg-opacity-5'
        }} py-2 px-2 hover:bg-blue hover:bg-opacity-20  {{
          variant === '_MENU' ? 'w-full' : 'w-85'
        }} mb-2 h-auto"
        (click)="selectedOption(option)"
      >
        <div class="w-full flex items-center gap-3 justify-around blank-image relative">
          <app-avatar
            *ngIf="option.value !== '_ADD_GROUP'"
            class="{{ variant === '_MENU' ? 'h-8 w-8' : 'h-12 w-12' }} cursor-pointer flex-shrink"
            classNames="{{ variant === '_MENU' ? 'h-8 w-8' : 'h-12 w-12' }}"
            [withFrame]="false"
            [src]="option?.src!"
            [withPreview]="false"
          ></app-avatar>
          <div
            *ngIf="option.value === '_ADD_GROUP'"
            class=" {{
              variant === '_MENU' ? 'h-8 w-8' : 'w-12 h-12'
            }} flex items-center justify-center bg-white rounded-full"
            aria-label="plus icon"
            [inlineSVG]="'assets/svg/plus.svg'"
            (click)="handleGroupActions('_CREATE_GROUP', option)"
          ></div>
          <div
            class="flex items-start justify-start {{
              option.label === pickValue?.label
                ? ' text-white transition-none'
                : variant === '_MENU'
                ? 'text-white'
                : 'text-blue'
            }} flex-col {{
              variant === '_MENU' && option.value !== '_ADD_GROUP' ? 'w-[185px]' : 'flex-grow'
            }}"
          >
            <span
              class="inline-block {{ variant === '_MENU' ? 'w-full' : 'w-11/12' }} {{
                option.value !== '_ADD_GROUP' ? 'capitalize' : ''
              }} text-sm"
            >
              {{ option?.label }}
            </span>
          </div>
          <div
            class="w-10 h-10 absolute rounded-full right-0"
            (click)="selectedOption(option)"
          ></div>
          <input
            *ngIf="option.value !== '_ADD_GROUP'"
            [checked]="option.label === pickValue?.label"
            type="radio"
            class="w-4 h-4 p-1 accent-corporateblue cursor-pointer"
            (click)="selectedOption(option)"
          />
        </div>
      </div>
    </ul>
  </div>
</div>
<ng-template #filterDropdown>
  <div
    class="w-full flex items-center gap-3 {{
      variant === '_MENU' ? 'justify-around' : 'justify-between'
    }}  blank-image"
  >
    <app-avatar
      class="{{ variant === '_MENU' ? 'h-8 w-8' : 'h-10 w-10' }} cursor-pointer {{
        variant === '_MENU' ? 'flex-shrink' : ''
      }}"
      classNames="{{ variant === '_MENU' ? 'h-8 w-8' : 'h-10 w-10' }}"
      [withFrame]="false"
      caller="_ROLE_SELECT"
      [src]="pickValue?.src!"
      [withPreview]="false"
    ></app-avatar>
    <div
      class="w-[185px] flex items-center justify-center uppercase  flex-col {{
        variant === '_MENU' ? ' text-white' : 'text-blue'
      }}"
    >
      <span
        class="{{
          caller === '_CORPORATE'
            ? 'text-xs w-[120px]'
            : variant === '_MENU'
            ? 'text-[14px]  w-full'
            : 'text-sm w-full'
        }} text-center  overflow-hidden whitespace-nowrap overflow-ellipsis"
      >
        {{ pickValue?.label }}
      </span>
      <div
        *ngIf="
          variant !== '_MENU' &&
          pickValue!.value !== '_ADD_GROUP' &&
          pickValue!.value !== 'admin' &&
          isGroupOwer(pickValue!)
        "
        class="mt-1 {{
          caller === '_CORPORATE' ? 'text-[8px]' : 'text-[10px] '
        }} hover:underline cursor-pointer text-center bg-kimbo-blue rounded-sm px-2 h-6 text-white flex items-center font-medium gap-1"
        (click)="handleGroupActions('_EDIT_GROUP', pickValue!)"
      >
        <img
          appImg
          *ngIf="caller !== '_CORPORATE'"
          src="assets/images/add-group_.png"
          class="w-4"
          alt="add-group"
        />
        <span>{{ 'common.edit-button' | translate }}</span>
      </div>
    </div>

    <img
      appImg
      src="assets/svg/arrow-bottom.svg"
      class="h-6 w-6 {{ isOpen ? 'rotate-180' : '' }}"
      alt="arrow-bottom"
    />
  </div>
</ng-template>
